"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAnvilFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.anvil_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "anvil_filled_svg__transparent_box" },
            React.createElement("path", { className: "anvil_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "anvil_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "anvil_filled_svg__FILLED" },
            React.createElement("path", { d: "M2 5v6h1c2.47 0 4.3.58 5.15 1.61.49.58.83 1.15.82 3.14V19H19v-1a2 2 0 012-2V5zM23 7v8.62a12.5 12.5 0 008-7.3L31.39 7zM23 21H5v5h18" }))));
}
exports.default = SvgAnvilFilled;
//# sourceMappingURL=AnvilFilled.js.map